import * as RewardsActionTypes from '../actionTypes/RewardsActionTypes';

export const rewardsPageLoadedAction = (pageName) => ({
    type: RewardsActionTypes.REWARDS_PAGE_LOADED_SUCCESS,
    payload: pageName,
});

export const rewardsPageLoadedErrorAction = (pageName, data) => ({
    type: RewardsActionTypes.REWARDS_PAGE_LOADED_ERROR,
    payload: { pageName, data },
});

export const getRewards = (isDesktop, redirect, enableThirdPartyCoupons, disableExpand) => ({
    type: RewardsActionTypes.GET_REWARDS_REQUEST,
    payload: { isDesktop, redirect, enableThirdPartyCoupons, disableExpand },
});

export const getPrintRewards = (pageName) => ({
    type: RewardsActionTypes.REWARDS_PRINT_SELECTION,
    payload: pageName,
});

export const getCertificatesSel = (isExpire, popup, useRewards) => ({
    type: RewardsActionTypes.REWARDS_CERTIFICATE_SELECTION,
    payload: { isExpire, popup, useRewards },
});

export const updateRewardsSettings = (payload, userAction) => ({
    type: RewardsActionTypes.UPDATE_REWARDS_SETTINGS,
    payload,
    userAction,
});

export const linkCreditCard = (payload) => ({
    type: RewardsActionTypes.LINK_CREDITCARD,
    payload,
});

export const getRewardsNavPanelData = (data) => ({
    type: RewardsActionTypes.NAV_PAGE_SELECETION,
    payload: data,
});

export const rewardsMigrationAction = (data) => ({
    type: RewardsActionTypes.REWARDS_MIGRATION_SUCCESS,
    payload: data,
});

export const rewardsProfileUpdateAction = (data) => ({
    type: RewardsActionTypes.REWARDS_PROFILE_UPDATE_SUCCESS,
    payload: data,
});

export const rewardsDataTrackerAction = (data) => ({
    type: RewardsActionTypes.REWARDS_DATA_TRACKER,
    payload: data,
});

export const clearMissingPoints = () => ({
    type: RewardsActionTypes.ACCOUNT_CLEAR_MISSING_POINTS,
});

export const missingPointModalEvent = () => ({
    type: RewardsActionTypes.TRACK_OPEN_MISSING_MODAL,
});

// export default getRewards;
